const BanzaAutoCompletePresets = {
  BanzaAutoComplete: {
    class: "banza-edit banza-autocomplete",
    attrs: {
      density: "compact",
      variant: "outlined"
    },
    slots: {
      disabled: {
        icon: {
          attrs: {
            class: "disabled-icon",
            size: "16",
            icon: "$b-disabled"
          }
        }
      }
    },
    presets: {}
  }
};
export {
  BanzaAutoCompletePresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFBdXRvQ29tcGxldGVQcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFuemFBdXRvQ29tcGxldGVQcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0QmFuemFBdXRvQ29tcGxldGU6IHtcblx0XHRjbGFzczogXCJiYW56YS1lZGl0IGJhbnphLWF1dG9jb21wbGV0ZVwiLFxuXHRcdGF0dHJzOiB7XG5cdFx0XHRkZW5zaXR5OiBcImNvbXBhY3RcIixcblx0XHRcdHZhcmlhbnQ6IFwib3V0bGluZWRcIixcblx0XHR9LFxuXHRcdHNsb3RzOiB7XG5cdFx0XHRkaXNhYmxlZDoge1xuXHRcdFx0XHRpY29uOiB7XG5cdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdGNsYXNzOiBcImRpc2FibGVkLWljb25cIixcblx0XHRcdFx0XHRcdHNpemU6IFwiMTZcIixcblx0XHRcdFx0XHRcdGljb246IFwiJGItZGlzYWJsZWRcIixcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHR9LFxuXHRcdHByZXNldHM6IHt9LFxuXHR9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFlLDJCQUFBO0FBQUEsRUFDZCxtQkFBbUI7QUFBQSxJQUNsQixPQUFPO0FBQUEsSUFDUCxPQUFPO0FBQUEsTUFDTixTQUFTO0FBQUEsTUFDVCxTQUFTO0FBQUEsSUFDVDtBQUFBLElBQ0QsT0FBTztBQUFBLE1BQ04sVUFBVTtBQUFBLFFBQ1QsTUFBTTtBQUFBLFVBQ0wsT0FBTztBQUFBLFlBQ04sT0FBTztBQUFBLFlBQ1AsTUFBTTtBQUFBLFlBQ04sTUFBTTtBQUFBLFVBQ047QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLElBQ0Q7QUFBQSxJQUNELFNBQVMsQ0FBRTtBQUFBLEVBQ1g7QUFDRjsifQ==
